// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"3425fada","381":"72c2a3dd","453":"8b4f96d0","482":"16565229","509":"59525b95"}[chunkId] + ".chunk.js";
};